import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveComponent as _resolveComponent, withModifiers as _withModifiers, renderList as _renderList, unref as _unref, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/drop-down.png'
import _imports_1 from '@/assets/image/resource/item1.png'
import _imports_2 from '@/assets/image/resource/item2.png'
import _imports_3 from '@/assets/image/icon/resource4.png'
import _imports_4 from '@/assets/image/icon/settle-in.png'
import _imports_5 from '@/assets/image/hot/submit-success.png'
import _imports_6 from '@/assets/image/hot/close2.png'


const _withScopeId = n => (_pushScopeId("data-v-00bbd407"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "header-options" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "search-container"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_8 = { class: "fixed-top-player-box" }
const _hoisted_9 = { class: "swiper-container" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "company-icon" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "safety-icon" }, null, -1))
const _hoisted_13 = { class: "company-card-header" }
const _hoisted_14 = { class: "company-info" }
const _hoisted_15 = { class: "company-info__name" }
const _hoisted_16 = { class: "company-info__type" }
const _hoisted_17 = { class: "text" }
const _hoisted_18 = { class: "company-card-main" }
const _hoisted_19 = { class: "item-content-row item-content-row1" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "item-content-row__icon"
}, null, -1))
const _hoisted_21 = { class: "item-content-row-right" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-content-row-right__title" }, " 可提供资源 ", -1))
const _hoisted_23 = { class: "item-content-row-right-tags" }
const _hoisted_24 = { class: "item-content-row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "item-content-row__icon"
}, null, -1))
const _hoisted_26 = { class: "item-content-row-right" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-content-row-right__title item-content-row-right__need" }, " 需要的资源 ", -1))
const _hoisted_28 = { class: "item-content-row-right-tags" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "show-video" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "video-icon" }),
  /*#__PURE__*/_createTextVNode(" 企业宣传 ")
], -1))
const _hoisted_30 = {
  key: 0,
  class: "slide-btns"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slide-btns__left" }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slide-btns__text" }, "滑动切换公司", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slide-btns__right" }, null, -1))
const _hoisted_34 = [
  _hoisted_31,
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = { class: "filter-picker" }
const _hoisted_36 = { class: "region-selection" }
const _hoisted_37 = { class: "settle-form" }
const _hoisted_38 = { class: "settle-form-header" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "settle-form-header-title" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }),
  /*#__PURE__*/_createElementVNode("div", { class: "settle-form-header-title__text" }, "填写入驻信息")
], -1))
const _hoisted_40 = { class: "settle-form-inputs" }
const _hoisted_41 = {
  key: 0,
  class: "form-item__info"
}
const _hoisted_42 = { class: "popup-tips" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup-tips__title" }, "温馨提示", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup-tips__content" }, "您尚未绑定企业，请前往绑定", -1))
const _hoisted_45 = { class: "success" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "success-img1",
  src: _imports_5
}, null, -1))

import { ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import MTaskTime from '@/components/MTaskTime/MTaskTime.vue'
import {
  List,
  Button,
  Popup,
  Picker,
  Field,
  DropdownMenu,
  DropdownItem,
  TreeSelect,
  Toast,
  Form,
  Overlay,
  Dialog,
  Swipe,
  SwipeItem,
  Tabs,
  Tab,
} from 'vant'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css/effect-cards'
import { EffectCards } from 'swiper'
import MTabsSwipe from '@/views/components/MTabsSwipe/MTabsSwipe.vue'
import MNoData2 from '@/views/components/MNoData2/MNoData2.vue'
import MTabbar from '@/components/MTabbar/MTabbar.vue'
import MSearch from '@/views/components/MSearch/MSearch.vue'
import MImage from '@/components/MImage/MImage.vue'
import MPopupPlayer from '@/views/components/MPopupPlayer/MPopupPlayer.vue'
import FooterTips from '@/views/components/FooterTips/FooterTips.vue'
import {
  getResourceInformations,
  getHadResourceIndustryH5,
  applyZcjResourceEnterInformation,
  getResourceType,
  resourceSendPhoneNumber,
  getHadResourceCity,
} from '@/api/resource'
import { getHomeBanner } from '@/api/home'
import { useUserStore } from '@/store/modules/user'
import { SEARCH_TYPE_POPUP_COLUMNS, RESOURCE_FILTER_TYPE } from '@/constant'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourceList',
  setup(__props) {

const router = useRouter()
const userStore = useUserStore()

const defaultSearchType = {
  text: '公司名称',
  type: 1,
}
const overlayVisable = ref(false)
const searchTypePopup = ref(false)
const filterPopup = ref(false)
const filterPopup2 = ref(false)
const filterPopup3 = ref(false)
const filterPopup4 = ref(false)
const filterIndex = ref(0)
const locationActiveId = ref(-1)
const locationActiveindex = ref(-1)
const locationActiveId2 = ref(-1)
const locationActiveindex2 = ref(-1)
const isSend = ref(false)
const countdownSeconds = ref(60)
const buttonText = ref('获取验证码')
const popupPlayerRef = ref(null)
const params = reactive({
  pageNum: 1,
  pageSize: 10,
  customerName: '',
  needResourceTypeId: '',
  provideResourceTypeId: '',
  resourceIndustryTwoLevelId: '',
})
const state = reactive({
  loading: false,
  finished: false,
  resourceList: [],
  settleInPopup: false,
  noSettleInPopup: false,
  overlayVisable: false,
  isShowSearch: false, // 是否显示搜索框
  isShowFilter: false, // 是否显示筛选框
  isShowSlideTips: true, // 是否显示滑动切换公司
  searchActive: false, // 是否显示激活搜索icon
  filterActive: false, // 是否显示激活筛选icon
  citys: [],
  resourceIndustry: [],
  userInfo: userStore.userInfo,
  resourceType: [],
  isShowVideo: false,
  playobj: {},
  searchType: defaultSearchType,
  banner: [],
  modules: [EffectCards],
  cardActiveIndex: 0,
})
const field = reactive({
  companyName: {
    value: '',
    error: false,
    validator: (val) => {
      const reg = /^.+$/.test(val)
      if (reg === true) field.companyName.error = false
      return reg
    },
  },
  phoneNumber: {
    value: '',
    error: false,
    validator: (val) => {
      const reg =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
          val
        )
      if (reg === true) field.phoneNumber.error = false
      return reg
    },
  },
  code: {
    value: '',
    error: false,
    validator: (val) => {
      const reg = /^.+$/.test(val)
      if (reg === true) field.code.error = false
      return reg
    },
  },
  name: {
    value: '',
    error: false,
    validator: (val) => {
      const reg = /^.+$/.test(val)
      if (reg === true) field.name.error = false
      return reg
    },
  },
})

onMounted(async () => {
  fetchHadGoodsCity()
  fetchHadResourceIndustry()
  fetchResourceType()
  fetchHomeBanner()
  fetchResourceList()
  await userStore.getUserInfo()
  field.phoneNumber.value = userStore.userInfo?.phoneNumber
  field.companyName.value = userStore.userInfo?.bingdCompanyName
  setTimeout(() => {
    state.isShowSlideTips = false
  }, 3500)
})

const updateFilterIconStyle = () => {
  if (params.customerName) {
    state.searchActive = true
  } else {
    state.searchActive = false
  }
  if (
    params?.resourceIndustryOneLevelId ||
    params.resourceIndustryTwoLevelId ||
    params.needResourceTypeId ||
    params.provideResourceTypeId ||
    params.cityId ||
    params.areaId
  ) {
    state.filterActive = true
  } else {
    state.filterActive = false
  }
}

const fetchResourceList = async () => {
  state.loading = true
  updateFilterIconStyle()
  const res = await getResourceInformations({
    ...params,
    type: state.searchType.type,
  })
  state.resourceList = [...state.resourceList, ...res.data.list]
  state.finished = res.data.isLastPage
  state.loading = false
  params.pageNum++
}
const fetchHadGoodsCity = async () => {
  const { dataList = [] } = await getHadResourceCity()
  state.citys = dataList.map((item) => ({
    text: item.name,
    id: item.code,
    children: item.dto.map((children) => ({
      text: children.name,
      id: children.code,
    })),
  }))
}
const fetchHadResourceIndustry = async () => {
  const { dataList = [] } = await getHadResourceIndustryH5()
  state.resourceIndustry = dataList.map((item) => ({
    text: item.name,
    id: item.id,
    children: item.dto.map((children) => ({
      text: children.name,
      id: children.id,
    })),
  }))
}
const fetchResourceType = async () => {
  const res = await getResourceType()
  if (res.ret === 100) {
    state.resourceType = [
      { text: '全部', type: 0 },
      ...res.dataList.map((item) => ({
        ...item,
        text: item.resourceType,
        id: item.id,
      })),
    ]
  }
}
const fetchHomeBanner = async () => {
  const { dataList = [] } = await getHomeBanner({ advertisementType: 5 })
  state.banner = dataList
}
const handleRouterToDetail = (item) => {
  if (!userStore.userInfo?.companyId) {
    return Dialog.confirm({
      title: '温馨提示',
      message: '您尚未绑定企业，请前往绑定',
      confirmButtonColor: '#CB9E52',
    }).then(async () => {
      router.push('/user/enterprisebinding/bindingqiye')
    })
  }
  router.push({ path: `/resource-detail/${item.id}` })
}
const handleGetVerificationCode = async () => {
  if (!field.phoneNumber.value) return Toast('请输入手机号')
  const res = await resourceSendPhoneNumber({
    phoneNumber: field.phoneNumber.value,
  })
  if (res.ret === 100) {
    Toast('验证码已发送')
    isSend.value = true
    let i = 60
    let timer = setInterval(() => {
      i--
      countdownSeconds.value = i
      if (i < 0) {
        isSend.value = false
        buttonText.value = '重新获取验证码'
        countdownSeconds.value = 60
        clearInterval(timer)
      }
    }, 1000)
  }
}
const handleDropdownRef1Reset = () => {
  locationActiveId.value = -1
  locationActiveindex.value = -1
  params.cityId = ''
  params.areaId = ''
}
const handleDropdownRef1Confirm = () => {
  params.pageNum = 1
  state.resourceList = []
  fetchResourceList()
  state.isShowFilter = false
}
// 选择城市 搜索商品
const handleClickCity = (index) => {
  if (params.cityId && params.cityId === state.citys[index].id) {
    params.cityId = ''
    locationActiveindex.value = -1
  } else {
    params.cityId = state.citys[index].id
  }
  params.areaId = ''
  locationActiveId.value = -1
}
// 选择地区 搜索商品
const handleClickTreeSelect = (value) => {
  if (params.areaId && params.areaId === value.id) {
    params.areaId = ''
    locationActiveId.value = -1
  } else {
    params.areaId = value.id
  }
}
const handleDropdownRef2Reset = () => {
  locationActiveId2.value = -1
  locationActiveindex2.value = -1
  params.resourceIndustryOneLevelId = ''
  params.resourceIndustryTwoLevelId = ''
}
const handleDropdownRef2Confirm = () => {
  params.pageNum = 1
  state.resourceList = []
  fetchResourceList()
  state.isShowFilter = false
}
// 选择行业一级
const handleSelectIndustry1 = (index) => {
  if (
    params.resourceIndustryOneLevelId &&
    params.resourceIndustryOneLevelId === state.resourceIndustry[index].id
  ) {
    params.resourceIndustryOneLevelId = ''
    locationActiveindex2.value = -1
  } else {
    params.resourceIndustryOneLevelId = state.resourceIndustry[index].id
  }
  locationActiveId2.value = -1
  params.resourceIndustryTwoLevelId = ''
}
// 选择行业二级
const handleSelectIndustry2 = (value) => {
  if (
    params.resourceIndustryTwoLevelId &&
    params.resourceIndustryTwoLevelId === value.id
  ) {
    params.resourceIndustryTwoLevelId = ''
    locationActiveId2.value = -1
  } else {
    params.resourceIndustryTwoLevelId = value.id
  }
}
const handleApplySettled = () => {
  if (!field.companyName.value) {
    Dialog.confirm({
      title: '温馨提示',
      message: '您尚未绑定企业，请前往绑定',
      confirmButtonColor: '#CB9E52',
    })
      .then(async () => {
        router.push('/user/enterprisebinding/bindingqiye')
      })
      .catch(() => {
        // on cancel
      })
  } else {
    state.settleInPopup = true
  }
}
const onSubmit = async (values) => {
  const res = await applyZcjResourceEnterInformation(values)
  if (res.ret === 100) {
    state.settleInPopup = false
    overlayVisable.value = true
    field.name.value = ''
    field.phoneNumber.value = userStore.userInfo?.phoneNumber
    field.code.value = ''
    field.companyName.value = userStore.userInfo?.bingdCompanyName
  } else {
    Toast(res.msg)
  }
}
const onFailed = () => {
  Toast('请检查输入是否正确')
}
const onSearchTypePopupConfirm = (value) => {
  state.searchType = value
  searchTypePopup.value = false
}
const onChangeNeed = (value) => {
  params.needResourceTypeId = value.id
  params.pageNum = 1
  state.resourceList = []
  fetchResourceList()
}
const onChangeSupply = (value) => {
  params.provideResourceTypeId = value.id
  params.pageNum = 1
  state.resourceList = []
  fetchResourceList()
}

const handleSearch = () => {
  params.pageNum = 1
  state.resourceList = []
  fetchResourceList()
}
const handleCancel = () => {
  params.customerName = ''
  params.pageNum = 1
  state.resourceList = []
  fetchResourceList()
}
const handleBannerLinkTo = (linkUrl) => {
  location.href = linkUrl
}
const handleClickSearch = () => {
  state.isShowSearch = !state.isShowSearch
  state.isShowFilter = false
}
const handleClickFilter = () => {
  state.isShowFilter = !state.isShowFilter
  state.isShowSearch = false
}
const handleResetFilter = () => {
  params.pageNum = 1
  state.resourceList = []
  params.customerName = ''
  params.resourceIndustryOneLevelId = ''
  params.resourceIndustryTwoLevelId = ''
  params.needResourceTypeId = ''
  params.provideResourceTypeId = ''
  params.cityId = ''
  params.areaId = ''
  locationActiveId.value = -1
  locationActiveindex.value = -1
  locationActiveId2.value = -1
  locationActiveindex2.value = -1
  state.isShowSearch = false
  state.isShowFilter = false
  fetchResourceList()
}
const handleClickItem1 = () => {
  filterPopup.value = true
}
const handleClickItem2 = () => {
  filterPopup2.value = true
}
const handleClickItem3 = () => {
  filterPopup3.value = true
}
const handleClickItem4 = () => {
  filterPopup4.value = true
}
const onSlideChange = (item) => {
  state.cardActiveIndex = item.activeIndex
  for (const item of popupPlayerRef.value) {
    item.closePopPlayer()
  }
  if (state.finished) return
  if (state.loading) return
  if (state.cardActiveIndex === state.resourceList.length - 2) {
    fetchResourceList()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_MPlay = _resolveComponent("MPlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(MTaskTime, { type: 3 }),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", {
          class: _normalizeClass(["header-options__btns", { 'is-show-refresh': state.searchActive || state.filterActive }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["btn search", { 'search-active': state.searchActive }]),
            onClick: handleClickSearch
          }, null, 2),
          _hoisted_4,
          _createElementVNode("div", {
            class: _normalizeClass(["btn filter", { 'filter-active': state.filterActive }]),
            onClick: handleClickFilter
          }, null, 2),
          (state.searchActive || state.filterActive)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_5,
                _createElementVNode("div", {
                  class: "btn refresh",
                  onClick: handleResetFilter
                })
              ], 64))
            : _createCommentVNode("", true)
        ], 2),
        (state.isShowSearch)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(MSearch, {
                modelValue: params.customerName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((params.customerName) = $event)),
                onHandleChange: handleSearch,
                onHandleCancel: handleCancel
              }, {
                "left-content": _withCtx(() => [
                  _createElementVNode("div", {
                    class: "search-slot",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (searchTypePopup.value = true))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(state.searchType.text), 1),
                    _hoisted_7
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (state.isShowVideo)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed-top-player-pop",
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closePopPlayer && _ctx.closePopPlayer(...args)), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_MPlay, {
                class: "fixed-top-player",
                playobj: state.playobj
              }, null, 8, ["playobj"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_unref(Swipe), {
        class: "header-swipe",
        autoplay: 3000
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.banner, (item) => {
            return (_openBlock(), _createBlock(_unref(SwipeItem), {
              key: item.imgUrl
            }, {
              default: _withCtx(() => [
                _createVNode(MImage, {
                  src: item.imgUrl,
                  "data-src": item.imgUrl,
                  onClick: ($event: any) => (handleBannerLinkTo(item.linkUrl))
                }, null, 8, ["src", "data-src", "onClick"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }),
      (state.resourceList.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(Swiper), {
                effect: 'slide',
                grabCursor: true,
                modules: state.modules,
                class: "mySwiper",
                onSlideChange: onSlideChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.resourceList, (item) => {
                    return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                      key: item.id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "company-card",
                          onClick: ($event: any) => (handleRouterToDetail(item))
                        }, [
                          _hoisted_11,
                          _hoisted_12,
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(MImage, {
                              class: "avatar",
                              type: "avatar",
                              src: item.logoUrl
                            }, null, 8, ["src"]),
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, _toDisplayString(item.customerName), 1),
                              _createElementVNode("span", _hoisted_16, [
                                _createElementVNode("span", _hoisted_17, _toDisplayString(item.resourceIndustryOneLevel), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _hoisted_20,
                              _createElementVNode("div", _hoisted_21, [
                                _hoisted_22,
                                _createElementVNode("div", _hoisted_23, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.availableResourcess, (available) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: available,
                                      class: "item-content-row-right-tags__tag"
                                    }, _toDisplayString(available), 1))
                                  }), 128))
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              _hoisted_25,
                              _createElementVNode("div", _hoisted_26, [
                                _hoisted_27,
                                _createElementVNode("div", _hoisted_28, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.resourcesNeededs, (need) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: need,
                                      class: "item-content-row-right-tags__tag need"
                                    }, _toDisplayString(need), 1))
                                  }), 128))
                                ])
                              ])
                            ]),
                            _createVNode(MPopupPlayer, {
                              ref_for: true,
                              ref_key: "popupPlayerRef",
                              ref: popupPlayerRef,
                              vid: item.video
                            }, {
                              default: _withCtx(() => [
                                _hoisted_29
                              ]),
                              _: 2
                            }, 1032, ["vid"])
                          ])
                        ], 8, _hoisted_10)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modules"])
            ]),
            (state.isShowSlideTips)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_34))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createBlock(MNoData2, {
            key: 2,
            class: "no-data"
          })),
      _createVNode(FooterTips),
      _createElementVNode("div", { class: "settle" }, [
        _createElementVNode("img", {
          onClick: handleApplySettled,
          src: _imports_3
        })
      ]),
      _createVNode(MTabbar)
    ]),
    _createVNode(_unref(Popup), {
      show: searchTypePopup.value,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((searchTypePopup).value = $event)),
      round: "",
      position: "bottom",
      style: { height: '300px' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_unref(Picker), {
            columns: _unref(SEARCH_TYPE_POPUP_COLUMNS),
            "default-index": defaultSearchType.type,
            onCancel: _cache[3] || (_cache[3] = ($event: any) => (searchTypePopup.value = false)),
            onConfirm: onSearchTypePopupConfirm
          }, null, 8, ["columns", "default-index"])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(Popup), {
      show: state.isShowFilter,
      "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => ((state.isShowFilter) = $event)),
      round: "",
      position: "bottom",
      teleport: ".container",
      style: { height: '420px' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_36, [
          _createVNode(MTabsSwipe, {
            modelValue: filterIndex.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filterIndex).value = $event)),
            tabs: _unref(RESOURCE_FILTER_TYPE)
          }, {
            default: _withCtx((slot) => [
              (slot.tabsActive === 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_unref(TreeSelect), {
                      "active-id": locationActiveId.value,
                      "onUpdate:activeId": _cache[5] || (_cache[5] = ($event: any) => ((locationActiveId).value = $event)),
                      "main-active-index": locationActiveindex.value,
                      "onUpdate:mainActiveIndex": _cache[6] || (_cache[6] = ($event: any) => ((locationActiveindex).value = $event)),
                      items: state.citys,
                      onClickItem: handleClickTreeSelect,
                      onClickNav: handleClickCity
                    }, null, 8, ["active-id", "main-active-index", "items"]),
                    _createElementVNode("div", { class: "btns-group" }, [
                      _createElementVNode("div", {
                        class: "btns-group__reset",
                        onClick: handleDropdownRef1Reset
                      }, " 重置 "),
                      _createElementVNode("div", {
                        class: "btns-group__confirm",
                        onClick: handleDropdownRef1Confirm
                      }, " 确认 ")
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (slot.tabsActive === 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_unref(TreeSelect), {
                      "active-id": locationActiveId2.value,
                      "onUpdate:activeId": _cache[7] || (_cache[7] = ($event: any) => ((locationActiveId2).value = $event)),
                      "main-active-index": locationActiveindex2.value,
                      "onUpdate:mainActiveIndex": _cache[8] || (_cache[8] = ($event: any) => ((locationActiveindex2).value = $event)),
                      items: state.resourceIndustry,
                      onClickItem: handleSelectIndustry2,
                      onClickNav: handleSelectIndustry1
                    }, null, 8, ["active-id", "main-active-index", "items"]),
                    _createElementVNode("div", { class: "btns-group" }, [
                      _createElementVNode("div", {
                        class: "btns-group__reset",
                        onClick: handleDropdownRef2Reset
                      }, " 重置 "),
                      _createElementVNode("div", {
                        class: "btns-group__confirm",
                        onClick: handleDropdownRef2Confirm
                      }, " 确认 ")
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (slot.tabsActive === 2)
                ? (_openBlock(), _createBlock(_unref(Picker), {
                    key: 2,
                    columns: state.resourceType,
                    "default-index": 0,
                    "show-toolbar": false,
                    onChange: onChangeNeed
                  }, null, 8, ["columns"]))
                : _createCommentVNode("", true),
              (slot.tabsActive === 3)
                ? (_openBlock(), _createBlock(_unref(Picker), {
                    key: 3,
                    columns: state.resourceType,
                    "default-index": 0,
                    "show-toolbar": false,
                    onChange: onChangeSupply
                  }, null, 8, ["columns"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "tabs"])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(Popup), {
      show: state.settleInPopup,
      "onUpdate:show": _cache[15] || (_cache[15] = ($event: any) => ((state.settleInPopup) = $event)),
      round: "",
      position: "bottom",
      style: { height: 'auto', 'padding-bottom': '20px' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_37, [
          _createVNode(_unref(Form), {
            "show-error": false,
            "show-error-message": false,
            "validate-trigger": "onBlur",
            onSubmit: onSubmit,
            onFailed: onFailed
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createVNode(_unref(Button), { "native-type": "submit" }, {
                  default: _withCtx(() => [
                    _createTextVNode("提交")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_unref(Field), {
                  modelValue: field.name.value,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((field.name.value) = $event)),
                  required: "",
                  name: "name",
                  label: "姓名：",
                  placeholder: "请输入用户名",
                  rules: [
              {
                validator: field.name.validator,
                message: '请输入姓名',
              },
            ]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_unref(Field), {
                  modelValue: field.phoneNumber.value,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((field.phoneNumber.value) = $event)),
                  name: "phoneNumber",
                  required: "",
                  label: "手机号码：",
                  placeholder: "请输入手机号码",
                  rules: [
              {
                validator: field.phoneNumber.validator,
                message: '请输入手机号码',
              },
            ]
                }, {
                  button: _withCtx(() => [
                    (isSend.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, " 获取验证码" + _toDisplayString(countdownSeconds.value) + "s ", 1))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "form-item__info",
                          onClick: handleGetVerificationCode
                        }, _toDisplayString(buttonText.value), 1))
                  ]),
                  _: 1
                }, 8, ["modelValue", "rules"]),
                _createVNode(_unref(Field), {
                  modelValue: field.code.value,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((field.code.value) = $event)),
                  required: "",
                  name: "code",
                  label: "验证码：",
                  placeholder: "请输入验证码",
                  maxlength: "6",
                  rules: [
              {
                validator: field.code.validator,
                message: '请输入验证码',
              },
            ]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_unref(Field), {
                  modelValue: field.companyName.value,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((field.companyName.value) = $event)),
                  required: "",
                  name: "companyName",
                  label: "公司名称：",
                  placeholder: "请输入公司名称",
                  rules: [
              {
                validator: field.companyName.validator,
                message: '请输入公司名称',
              },
            ]
                }, null, 8, ["modelValue", "rules"])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(Popup), {
      show: state.noSettleInPopup,
      "onUpdate:show": _cache[17] || (_cache[17] = ($event: any) => ((state.noSettleInPopup) = $event)),
      round: "",
      position: "center"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _hoisted_44,
          _createElementVNode("div", {
            class: "popup-tips__footer",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (state.noSettleInPopup = false))
          }, " 确定 ")
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(Overlay), { show: overlayVisable.value }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_45, [
          _hoisted_46,
          _createElementVNode("img", {
            class: "success-img2",
            src: _imports_6,
            onClick: _cache[18] || (_cache[18] = ($event: any) => (overlayVisable.value = false))
          })
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})